import React from "react";
import "./index.css";

// ScrollAnimation component (reused from previous components)
class ScrollAnimation extends React.Component {
  state = {
    isVisible: false,
  };

  domRef = React.createRef();

  componentDidMount() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.setState({ isVisible: true });
        observer.unobserve(this.domRef.current);
      }
    });

    observer.observe(this.domRef.current);
  }

  render() {
    const { children, stagger } = this.props;
    const staggerClass = stagger ? `stagger-${stagger}` : "";

    return (
      <div
        className={`contact-scroll-animation ${
          this.state.isVisible ? "is-visible" : ""
        } ${staggerClass}`}
        ref={this.domRef}
      >
        {children}
      </div>
    );
  }
}

class Contact extends React.Component {
  state = {
    formData: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },
    errors: {},
    submitted: false,
    buttonText: "Submit", // NEW
  };

  // Form validation
  validateForm = () => {
    const { formData } = this.state;
    let errors = {};
    let isValid = true;

    // Name validation
    if (!formData.name || formData.name.length < 2) {
      errors.name = "Name must be at least 2 characters";
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Phone validation - optional
    if (formData.phone && formData.phone.length < 7) {
      errors.phone = "Please enter a valid phone number";
      isValid = false;
    }

    // Message validation
    if (!formData.message || formData.message.length < 10) {
      errors.message = "Message must be at least 10 characters";
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  // Handle input changes
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  // Form submission handler
  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.validateForm()) {
      this.setState({ buttonText: "Sending..." });

      const { formData } = this.state;

      const submission = new FormData();
      submission.append("access_key", "0c0a7733-d67b-4bb5-bb9b-d7ad93d16f66");
      submission.append("name", formData.name);
      submission.append("email", formData.email);
      submission.append("phone", formData.phone);
      submission.append("message", formData.message);
      submission.append(
        "subject",
        "Someone Messaged you from your Landing page"
      );

      try {
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: submission,
        });

        const data = await response.json();

        if (data.success) {
          this.setState({
            submitted: true,
            formData: {
              name: "",
              email: "",
              phone: "",
              message: "",
            },
            errors: {},
            buttonText: "Message Sent ✅",
          });

          setTimeout(() => {
            this.setState({ submitted: false, buttonText: "Submit" });
          }, 5000);
        } else {
          alert("Submission failed: " + data.message);
          this.setState({ buttonText: "Submit" });
        }
      } catch (error) {
        console.error("Submission error:", error);
        alert("An error occurred while submitting the form.");
        this.setState({ buttonText: "Submit" });
      }
    }
  };

  render() {
    const { formData, errors, submitted } = this.state;

    return (
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <ScrollAnimation>
            <div className="contact-header">
              <h2 className="contact-title">
                Contact <span className="contact-title-highlight">Us</span>
              </h2>
              <div className="contact-divider"></div>
              <p className="contact-subtitle">
                Have questions or need more information about our services? We'd
                love to hear from you!
              </p>
            </div>
          </ScrollAnimation>

          <div className="contact-content">
            <ScrollAnimation>
              <div className="contact-info-card">
                <h3 className="contact-info-title">Get in Touch</h3>

                <div className="contact-info-item">
                  <div className="contact-info-icon-wrapper">
                    <i className="contact-info-icon ri-map-pin-line"></i>
                  </div>
                  <div className="contact-info-text">
                    <h4 className="contact-info-label">Address</h4>
                    <p className="contact-info-detail">
                      80 E Midlothian Blvd, Youngstown, OH, United States, Ohio
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon-wrapper">
                    <i className="contact-info-icon ri-phone-line"></i>
                  </div>
                  <div className="contact-info-text">
                    <h4 className="contact-info-label">Phone</h4>
                    <p className="contact-info-detail">330-967-8874</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon-wrapper">
                    <i className="contact-info-icon ri-mail-line"></i>
                  </div>
                  <div className="contact-info-text">
                    <h4 className="contact-info-label">Email</h4>
                    <p className="contact-info-detail">
                      swlwenterprise@gmail.com
                    </p>
                  </div>
                </div>

                <h3 className="contact-social-title">Connect With Us</h3>
                <div className="contact-social-links">
                  <a
                    href="https://www.facebook.com/wlwenterpriseohio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/wlwenterprise/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                  >
                    <i className="ri-instagram-line"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/wlw-enterprise-753a98365/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-link"
                  >
                    <i className="ri-linkedin-fill"></i>
                  </a>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation>
              <div className="contact-form-card">
                <h3 className="contact-form-title">Send Us a Message</h3>

                <form onSubmit={this.handleSubmit} className="contact-form">
                  <div className="contact-form-field">
                    <label className="contact-form-label">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={this.handleChange}
                      placeholder="Your Name"
                      className="contact-form-input"
                    />
                    {errors.name && (
                      <span className="contact-form-error">{errors.name}</span>
                    )}
                  </div>
                  <div className="contact-form-field">
                    <label className="contact-form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={this.handleChange}
                      placeholder="your.email@example.com"
                      className="contact-form-input"
                    />
                    {errors.email && (
                      <span className="contact-form-error">{errors.email}</span>
                    )}
                  </div>
                  <div className="contact-form-field">
                    <label className="contact-form-label">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={this.handleChange}
                      placeholder="(123) 456-7890"
                      className="contact-form-input"
                    />
                    {errors.phone && (
                      <span className="contact-form-error">{errors.phone}</span>
                    )}
                  </div>
                  <div className="contact-form-field">
                    <label className="contact-form-label">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={this.handleChange}
                      placeholder="How can we help you?"
                      rows={4}
                      className="contact-form-textarea"
                    ></textarea>
                    {errors.message && (
                      <span className="contact-form-error">
                        {errors.message}
                      </span>
                    )}
                  </div>
                  <div className="contact-form-submit">
                    <button type="submit" className="contact-submit-button">
                      {this.state.buttonText}
                    </button>
                  </div>
                  {submitted && (
                    <div className="contact-success-message">
                      <p>
                        Message sent! We'll get back to you as soon as possible.
                      </p>
                    </div>
                  )}
                </form>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;
